import { useState, useEffect } from 'react';
import { courseService } from '../services/courseService';

export const useCourses = (userId = null) => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCourses = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await courseService.fetchCourses(userId);
      
      // Process the response - only show public courses in main dashboard
      let allCourses = [];
      if (data.public_courses) {
        allCourses = [...data.public_courses];
      }
      
      setCourses(allCourses);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching courses:', err);
    } finally {
      setLoading(false);
    }
  };

  const fetchCoursesByGroup = async (groupId) => {
    try {
      setLoading(true);
      setError(null);
      const data = await courseService.fetchCoursesByGroup(groupId, userId);
      setCourses(data.courses || []);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching group courses:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId !== null) {
      fetchCourses();
    }
  }, [userId]);

  return {
    courses,
    loading,
    error,
    fetchCourses,
    fetchCoursesByGroup,
  };
}; 